if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {

		constructor(){

			super();

			this.setupProductGallery();

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && ( KROWN.settings.cart_action === 'overlay' || KROWN.settings.cart_action === 'popup' ) ) {
				
				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode === window.KEYCODES.RETURN ) {
							addToCartEnter = true;
							window.lastFocusedElm = this.querySelector('[data-js-product-add-to-cart]');
						}
					})
				}	

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
								addToCartEnter = false;
							}, 200);
						}
					});
				}

			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}


			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.variantChangeHandler = this.onVariantChangeHandler.bind(this);
				this.productVariants.addEventListener('VARIANT_CHANGE', this.variantChangeHandler);
				this.onVariantChangeHandler({
					target: this.productVariants,
					initialVariant: true
				});
			}
		}

		setupProductGallery(){
			this.galleryListeners?.abort();
			this.galleryListeners = new AbortController();
			const listenerOptions = { signal: this.galleryListeners.signal };
			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.productGallery?.querySelector('css-slider');
			const slider = this.productSlider;
			const thumbnails = this.querySelector('.product-gallery__thumbnails-holder');
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((button)=>{
				button.addEventListener('click',()=>{
					const index = Number(button.dataset.index);
					if ( slider?.sliderEnabled ) {
						slider.changeSlide(index, window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth');
					} else {
						const item = this.productGallery?.querySelector(`.product-gallery-item[data-index="${index}"]`);
						if ( item ) window.scrollTo({top: item.getBoundingClientRect().top + window.scrollY, behavior: 'smooth'});
						this.#thumbnailNavigationHelper(index);
					}
					thumbnails?.scrollTo({left: button.offsetLeft - 50, behavior: 'smooth'});
				}, listenerOptions);
			});
			if ( slider ) {
				const ready = ()=>{
					if ( this.firstProductGalleryIndex !== undefined && slider.sliderEnabled ) {
						slider.changeSlide(Number(this.firstProductGalleryIndex), 'instant');
						this.firstProductGalleryIndex = undefined;
					}
				};
				slider.addEventListener('ready', ready, listenerOptions);
				slider.addEventListener('change',()=>{
					this.#thumbnailNavigationHelper(Number(slider.index));
					const item = this.productGallery.querySelector(`.product-gallery-item[data-index="${slider.index}"]`);
					if ( item?.dataset.productMediaType === 'model' && this.xrButton ) {
						this.xrButton.setAttribute('data-shopify-model3d-id', item.dataset.mediaId);
						slider.querySelector('.css-slider-holder')?.classList.add('css-slider--disable-dragging');
					}
				}, listenerOptions);
				if ( this.productGallery.dataset.jsDisableParallax === 'false' ) {
					slider.addEventListener('scroll',()=>{
						if ( !slider.element ) return;
						slider.querySelectorAll('.product-gallery-item').forEach((slide)=>{
							const figure = slide.querySelector('.apply-gallery-animation');
							if ( figure ) figure.style.transform = `translateX(${(slide.offsetLeft - slider.element.scrollLeft) * -1/3}px)`;
						});
					}, listenerOptions);
				}
				ready();
			}
			this.#thumbnailNavigationHelper(0);
		}

		disconnectedCallback(){
			this.galleryListeners?.abort();
			this.productVariants?.removeEventListener('VARIANT_CHANGE', this.variantChangeHandler);
		}

		#thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				elm.setAttribute('aria-current', String(i === Number(index)));
				if ( i === Number(index) )
					elm.classList.add('active');
				else 
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( e.initialVariant && variant ) {
				const url = new URL(window.location.href);
				const requested = url.searchParams.get('variant');
				if ( requested && requested !== String(variant.id) && !this.productVariants.querySelector(`[data-variant-id="${requested}"]`) ) {
					url.searchParams.set('variant', variant.id);
					window.history.replaceState({}, '', url.href);
				}
			}
			const nextGallery = this.querySelector('[data-js-product-gallery]');
			if ( nextGallery !== this.productGallery ) this.setupProductGallery();
			if ( this.querySelector('[data-lala-variant-gallery]') ) {
				this.firstProductGalleryIndex = 0;
				if ( this.productSlider?.sliderEnabled ) {
					this.productSlider.changeSlide(0, 'instant');
					this.firstProductGalleryIndex = undefined;
				}
				this.#thumbnailNavigationHelper(0);
				return;
			}
			if ( variant ) {
				
				// image handling

				if ( variant.featured_media?.id && this.productGallery ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								const galleryBehavior = e.initialVariant || window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth';
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index, galleryBehavior);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else if ( ! e.initialVariant ) {
							window.scrollTo({
								top: variantImg.offsetTop,
								behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
							});
						}
					}
				}

			}
		}
	}

  if ( typeof customElements.get('product-page') === 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
